<script>
import { forOwn } from 'lodash'
import lazyLoadComponent from '@router/lazyload-component'

export default {
  components: { At: () => lazyLoadComponent(import('@components/At')) },
  props: {
    itemName: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      tryingStore: false,
      mapTemplateString: {
        姓名: '黃大明',
        訂單成立時間: ' 2020/01/01 00:00 ',
        店家名稱: '樂活瑜珈',
        寺廟名稱: '武德宮',
        預約時間: ' 2020/01/03 13:00 ',
        訂單繳費期限: ' 2020/01/03 13:00 ', // 同活動開始時間
        日期: ' 2020/01/03 13:00 ',
        創建日期: ' 2020/01/03 13:00 ',
        付款時間: ' 2020/01/01 10:00 ',
        登記項目: '祈福法會',
        人數: ' 1 ',
        數量: ' 1 ',
        短網址: ' dsth.me/yoga ',
      },
      mapEnableMessage: {
        order_Qrcode: {
          sms: '客戶會在付款後收到入場憑證簡訊',
          email: '客戶會在付款後收到入場憑證電子郵件',
        },
        order_CheckoutLink: {
          sms: '客戶會在付款前收到繳款連結簡訊',
          email: '客戶會在付款前收到繳款連結電子郵件',
        },
        order_Remind: {
          sms: '客戶會在行前收到行程提醒簡訊',
          email: '客戶會在行前收到行程提醒電子郵件',
        },
        order_LightSerial: {
          sms: '客戶會在您手動將訂單狀態變更為已完成後收到簡訊',
          email: '客戶會在您手動將訂單狀態變更為已完成後收到通知信件',
        },
        order_LightSet: {
          sms: '客戶會在您手動將訂單狀態變更為待處理後收到簡訊',
          email: '客戶會在您手動將訂單狀態變更為待處理後收到通知信件',  
        },
        prepaid_Qrcode: {
          sms: '客戶會在預付方案付款完成後收到購買完成簡訊',
          email: '客戶會在預付方案付款完成後收到購買完成電子郵件',
        },
        prepaid_CheckoutLink: {
          sms: '客戶會在選購預付方案後收到付款連結簡訊',
          email: '客戶會在選購預付方案後收到付款連結電子郵件',
        },
      },
      mapSmsFixedPhrase: {
        order_Qrcode: ['姓名','日期','寺廟名稱','登記項目','短網址'],
        order_CheckoutLink: ['姓名','日期','寺廟名稱','登記項目','數量','短網址'],
        order_Remind: ['姓名','日期','寺廟名稱','登記項目','數量'],
        order_LightSerial: ['姓名','創建日期','寺廟名稱','登記項目','短網址'],
        order_LightSet: ['姓名','創建日期','寺廟名稱','登記項目','短網址'],
        prepaid_Qrcode: ['姓名'],
        prepaid_CheckoutLink: ['姓名'],
      },
      mapEmailFixedPhrase: {
        order_Qrcode: ['姓名','付款時間'],
        order_CheckoutLink: ['姓名','訂單成立時間','訂單繳費期限'],
        order_Remind: ['姓名'],
        order_LightSerial: ['姓名','寺廟名稱','登記項目'],
        order_LightSet: ['姓名','寺廟名稱','登記項目'],
        prepaid_Qrcode: ['姓名'],
        prepaid_CheckoutLink: ['姓名'],
      },
      mapDefaultPreview: {
        order_Qrcode: {
          sms:
            "您登記[日期]的[寺廟名稱][登記項目]，入場憑證請點以下連結[短網址]",
          email:
            "您的訂單已於 [付款時間] 完成。您可於儀式期間出示信件中的QR Code完成報到",
        },
        order_CheckoutLink: {
          sms:
            "您已登記[寺廟名稱][日期]的[登記項目]，請點以下連結立即付款[短網址]",
          email:
            "您的訂單已於 [訂單成立時間] 成立，請於 [訂單繳費期限] 前完成付款",
        },
        order_Remind: {
          sms:
            "您已登記[日期][寺廟名稱]的[登記項目][數量]位，提醒您若要前往參加儀式請提前抵達現場。",
          email: "提醒您若要前往參加儀式，請提早抵達現場。"
        },
        order_LightSerial: {
          sms:
            "您於[創建日期]在[寺廟名稱]登記的[登記項目]已設立完畢，請點以下連結查看[短網址]",
          email: "您在[寺廟名稱]登記的[登記項目]已設立完畢，請進入網站查看序號" 
        },
        order_LightSet: {
          sms:
            "您於[創建日期]在[寺廟名稱]登記的[登記項目]已被受理，待設立完成將會再次發送訊息通知",
          email: "您在[寺廟名稱]登記的[登記項目]已被受理，待設立完成將會再次發送訊息通知"
        },
        prepaid_Qrcode: {
          sms: '',
          email: '',
        },
        prepaid_CheckoutLink: {
          sms:
            '您已向[店家名稱]購買預付方案「[預付方案名稱]」，請點以下連結立即付款完成結帳[短網址]',
          email: '您的訂單已於 [訂單成立時間] 成立',
        },
      },
    }
  },
  computed: {
    isSmsEnable() {
      return this.defaultValue.sms.receive === 1
    },
    isEmailEnable() {
      return this.defaultValue.email.receive === 1
    },
    isSmsUseTemplate() {
      return this.defaultValue.sms.useCustomTemplate === 1
    },
    isEmailUseTemplate() {
      return this.defaultValue.email.useCustomTemplate === 1
    },
    smsContent() {
      return !!this.defaultValue.sms.templateContentHTML ? this.defaultValue.sms.templateContentHTML : this.defaultValue.sms.templateContent
    }
  },
  // watch: {
  //   defaultValue: 'updateSubmitData',
  // },
  methods: {
    emitClose() {
      this.$emit('close')
      this.$refs.form.resetFields()
    },
    updateSubmitData() {
      this.submitData = Object.assign({}, this.defaultValue)
    },
    save() {
      this.tryingStore = true
      this.$emit('save', this.getSubmitData(), () => {
        this.tryingStore = false
      })
    },
    getSubmitData() {
      const submitData = {}
      const productType = this.itemName.split('_')[0]
      const itemType = this.itemName.split('_')[1]

      this.defaultValue.sms.templateContent = this.$refs.smsTemplate.getTemplateContent()
      this.defaultValue.sms.templateContentHTML = this.$refs.smsTemplate.getTemplateContentHTML()
      // this.defaultValue.email.templateContent = this.$refs.emailTemplate.getTemplateContent()
      // this.defaultValue.email.templateContent = this.$refs.emailTemplate.getTemplateContentHTML()

      forOwn(this.defaultValue, (config, sendType) => {
        if (submitData[sendType] === undefined) submitData[sendType] = {}
        submitData[sendType][productType] = {
          [itemType]: config,
        }
      })
      return submitData
    },
    previewContent(templateString = '') {
      let content = templateString
      if (content === null) return ''

      // let content = `樣式預覽： 親愛的{姓名}，感謝您的訂購！ 您已向{店家名稱}購買超值方案「新課體驗組合」，{預約時間}請點以下連結立即付款完成結帳{短網址}`
      Object.keys(this.mapTemplateString).forEach((key) => {
        content = content.replace(
          new RegExp(`{${key}}`, 'g'),
          this.mapTemplateString[key]
        )
      })
      content = content.replace(/\n/g,'<br>')
      return content
    },
    updateTemplate(type) {
      this.defaultValue[type].templateContent = this.$refs[
        `${type}Template`
      ].getTemplateContent()
      this.defaultValue[type].templateContentHTML = this.$refs[
        `${type}Template`
      ].getTemplateContentHTML()

      this.$nextTick(()=>{
        this.$forceUpdate()
      })
      
    },
  },
}
</script>

<template>
  <div :class="$style.config">
    <div class="sms">
      <h5 class="title">簡訊設定 <BaseIcon name="comment-dots" /></h5>
      <div class="enable-disable">
        <div class="disable"
          ><el-radio v-model="defaultValue.sms.receive" :label="0"
            >關閉簡訊通知</el-radio
          ></div
        >
        <div class="enable"
          ><el-radio v-model="defaultValue.sms.receive" :label="1"
            >啟用簡訊通知</el-radio
          ><span style="color: #aaaaaa;"
            >－{{ mapEnableMessage[itemName].sms }}</span
          ></div
        >
      </div>
      <el-divider></el-divider>
      <div v-show="isSmsEnable">
        <div
          ><el-radio v-model="defaultValue.sms.useCustomTemplate" :label="0"
            >預設內容：</el-radio
          ></div
        >
        <div class="content" v-html="mapDefaultPreview[itemName].sms">
          您已向[店家名稱]購買預付方案「[預付方案名稱]」，請點以下連結立即付款完成結帳[短網址]</div
        >
        <div
          ><el-radio v-model="defaultValue.sms.useCustomTemplate" :label="1"
            >自訂內容：</el-radio
          ></div
        >
        <div :class="['content', !isSmsUseTemplate ? 'disabled' : '']">
          <At
            ref="smsTemplate"
            :fixed-phrase="mapSmsFixedPhrase[itemName]"
            :content="smsContent"
            @update="updateTemplate('sms')"
          ></At>
          <!-- <el-input v-model="defaultValue.sms.templateContent"></el-input> -->

          <el-alert
            style="margin-top: 10px;"
            title="提醒您，簡訊實際字數計算會因參數長度有所不同。每則簡訊字數依實際計算為準。"
            type="info"
            show-icon
            :closable="true"
          >
          </el-alert>
          <div style="margin-top: 30px;">
            <div>樣式預覽：</div>
            <div
              style="margin-bottom: 30px;"
              v-html="previewContent(defaultValue.sms.templateContent)"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="email">
      <h5 class="title">郵件設定 <BaseIcon name="envelope" /></h5>
      <div class="enable-disable">
        <div class="disable"
          ><el-radio v-model="defaultValue.email.receive" :label="0"
            >關閉郵件通知</el-radio
          ></div
        >
        <div class="enable"
          ><el-radio v-model="defaultValue.email.receive" :label="1"
            >啟用郵件通知</el-radio
          ><span style="color: #aaaaaa;"
            >－{{ mapEnableMessage[itemName].email }}</span
          ></div
        >
      </div>
      <el-divider></el-divider>
      <div v-show="isEmailEnable">
        <div
          ><el-radio v-model="defaultValue.email.useCustomTemplate" :label="0"
            >預設內容：</el-radio
          ></div
        >
        <div class="content" v-html="mapDefaultPreview[itemName].email"> </div>

        <div
          ><el-radio v-model="defaultValue.email.useCustomTemplate" :label="1"
            >自訂內容：</el-radio
          ></div
        >
        <div :class="['content', !isEmailUseTemplate ? 'disabled' : '']">
          <At
            ref="emailTemplate"
            :fixed-phrase="mapEmailFixedPhrase[itemName]"
            :content="defaultValue.email.templateContent"
            @update="updateTemplate('email')"
          ></At>
          <div style="margin-top: 30px;">
            <div>樣式預覽：</div>
            <div
              style="margin-bottom: 30px;"
              v-html="previewContent(defaultValue.email.templateContent)"
            ></div>
          </div>
        </div>
      </div>
    </div> -->
    <el-button
      :loading="tryingStore"
      type="primary"
      style="width: 100%; margin-top: 50px;"
      @click="save"
      >儲存變更</el-button
    >
  </div>
</template>
<style lang="scss" module>
.config {
  :global {
    .disabled {
      opacity: 0.3;
      pointer-events: none;
    }
    .title {
      color: #bf7e45;
    }
    .content {
      padding-left: 25px;
      & + div {
        margin-top: 30px;
      }
    }

    .el-radio__input {
      vertical-align: top;
    }
    .enable-disable {
      .disable + .enable {
        margin-top: 20px;
      }
    }
  }
}
</style>
